// extracted by mini-css-extract-plugin
module.exports = {"quick-reply-chip":"quick-reply-chip___17Kbe","send-icon":"send-icon___2W0Sc"};